import { CACHE_TIME } from '@/const/cache';
import {
  CLOSET_SLOT_TIER_SLUG,
  CartTierValidationResponse
} from '@/types/Closet';

export type GetClosetStatusForProductTierArgs = {
  closetTierSlug: CLOSET_SLOT_TIER_SLUG;
};

export async function getClosetStatusForProductTier(
  args: GetClosetStatusForProductTierArgs
): Promise<CartTierValidationResponse | undefined> {
  const { closetTierSlug } = args;

  const request = await fetch(`/api/closet/validate`, {
    method: 'POST',
    body: JSON.stringify({
      tiers: [closetTierSlug]
    }),
    next: { revalidate: CACHE_TIME.NO_CACHE }
  });
  const closetData = (await request.json()) as {
    data: CartTierValidationResponse;
  };
  return closetData.data;
}
